/** Generated by @jobilla/openapi-codegen. Do not edit manually. */

import { z } from 'zod/v4'
import { taxIdDataVerificationSchema } from './TaxIdDataVerificationSchema'

export const taxIdDataSchema = z.object({
	type: z.string(),
	value: z.string(),
	verification: taxIdDataVerificationSchema,
})

export type TaxIdDataSchema = z.infer<typeof taxIdDataSchema>
